export const INPUT_READY_PRODUCTS = 'INPUT_READY_PRODUCTS';
export const INPUT_READY_PRODUCTS_SUCCESS = 'INPUT_READY_PRODUCTS_SUCCESS';
export const INPUT_READY_PRODUCTS_FAIL = 'INPUT_READY_PRODUCTS_FAIL';
export const SET_INPUT_PRODUCTS_PIECES = 'SET_INPUT_PRODUCTS_PIECES';

export const UPDATE_READY_PRODUCTS = 'UPDATE_READY_PRODUCTS';
export const UPDATE_READY_PRODUCTS_SUCCESS = 'UPDATE_READY_PRODUCTS_SUCCESS';
export const UPDATE_READY_PRODUCTS_FAIL = 'UPDATE_READY_PRODUCTS_FAIL';

export const SET_MARK = 'SET_MARK';
export const SET_LENGTH = 'SET_LENGTH';
export const SET_NORMATIVE_DOC = 'SET_NORMATIVE_DOC';
export const SET_OPERATION_NUM_ID = 'SET_OPERATION_NUM_ID';
export const SET_OPERATION_TYPE = 'SET_OPERATION_TYPE';
export const SET_PIECE_ID = 'SET_PIECE_ID';
export const SET_PIECE_NUM_ID = 'SET_PIECE_NUM_ID';
export const SET_PROFILE_SIZE = 'SET_PROFILE_SIZE';
export const SET_QC_DATE = 'SET_QC_DATE';
export const SET_QC_ID = 'SET_QC_ID';
export const SET_QTY = 'SET_QTY';
export const SET_THICKNESS = 'SET_THICKNESS';
export const SET_QUANTITY = 'SET_QUANTITY';
export const SET_QUANTITY_OFF = 'SET_QUANTITY_OFF';
export const SET_ZDVL_LINE_ID = 'SET_ZDVL_LINE_ID';
export const SET_ZDVL_LINE_NUM_ID = 'SET_ZDVL_LINE_NUM_ID';
export const SET_READY_UNIT = 'SET_READY_UNIT';
export const SET_READY_ATTRIBS_INHERIT = 'SET_READY_ATTRIBS_INHERIT';

export const ADD_INPUT_PIECE = 'ADD_INPUT_PIECE';
